@if (!parameters || (parameters.length === 0 && all)) {
  All {{ name }}
} @else {
  @if (parameters.length <= shortenedListCutoff) {
    {{ name }}: {{ parametersList }}
  } @else {
    {{ parameters.length }} {{ name }}
  }
}
